import React, { useState, useRef, useEffect } from "react";
import MyHeader from "./Header.module.css";
import HeaderAvatar from "../Avatar/HeaderAvatar";
import { useSelector, useDispatch } from "react-redux";
import { closeShareModal, closeVersionModal, openVersionModal } from '../../app/EditorSlice';
import DocumentMembers from "../Members/members";
import MembersDropdown from "../Members/MembersDropdown";
import MembersGroup from "../Members/MembersGroup";
import Modes from '../Modes';
import TemplateActiveToggle from '../TemplateToggle/TemplateActiveToggle';
import VersionModalContent from "../DocumnetVersion/VersionsModal/versionModalContent.js";
import VersionsModal from "../DocumnetVersion/VersionsModal/versionsModal.js";
import CompleteDocument from "../CompleteDoc/completeDoc.js";
import { ShareModalContent } from "../ShareModal/ShareModalContent/ShareModalContent";
import { ShareModal } from "../ShareModal/ShareModal";
import { Dropdown, Menu, Modal, Drawer, message } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { workwiseServices } from '../../api';
import shareBtn from '../../assets/share-file.svg';
import documentVersionIcon from '../../assets/document-version.png';
import completeIcon from '../../assets/complete.png';
import darkIcon from '../../assets/Dark-Mode.svg';
import TemplateThumbnail from '../TemplateThumbnail/templateThumbnail';

const RightHeader = ({ isMobile, leftRef, leftActionsRef }) => {
    const dispatch = useDispatch();
    const shareModalOpen = useSelector((state) => state.editor.modals.share);
    const versionDrawerOpen = useSelector((state) => state.editor.modals.version);
    const documentInformation = useSelector((state) => state.editor.documentInformation);
    const userInformation = useSelector((state) => state.editor.userInformation);
    const isReadOnly = useSelector((state) => state.editor.isReadOnly);
    const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
    const members = (documentInformation?.members || []).filter(m => m.id !== userInformation?.userId);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [membersDrawerOpen, setMembersDrawerOpen] = useState(false);
    const [membersDropdownVisible, setMembersDropdownVisible] = useState(false);
    const [sharePrivacy, setSharePrivacy] = useState(0);

    const handleComplete = async () => {
        Modal.confirm({
            title: 'Complete Document',
            content: 'Are you sure you want to complete the document? This action cannot be undone.',
            okText: 'Complete',
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    const { referenceId } = documentInformation || {};
                    if (referenceId) {
                        await workwiseServices.completeDocument(referenceId);
                        message.success('Document completed successfully.');
                    }
                } catch (e) {
                    console.error(e);
                    message.error('Failed to complete the document. Please try again.');
                }
            },
        });
    };

    const menu = (
        <Menu className={MyHeader.compactMenu}>
            {!isReadOnly && !isTemplateDocument && (
                <Menu.Item key="complete" onClick={handleComplete}>
                    <div className={MyHeader.menuItemContent}>
                        <img src={completeIcon} alt="Complete" className={MyHeader.menuIcon} />
                        <span className={MyHeader.menuIconLabel}>Complete Document</span>
                    </div>
                </Menu.Item>
            )}
            {members.length > 0 && !isTemplateDocument && (
                <Menu.SubMenu key="members" title={<div className={MyHeader.menuItemContent}>
                    <div className="member-avatar-container-small"><MembersGroup size={14} /></div>
                    <span className={MyHeader.menuIconLabel}>Members</span></div>}>
                    <Menu.Item key="members-preview" disabled style={{ cursor: 'default', padding: 8 }}>
                        <MembersDropdown />
                    </Menu.Item>
                </Menu.SubMenu>
            )}
            {!isReadOnly && !isTemplateDocument && (
                <Menu.Item key="versions" onClick={() => dispatch(openVersionModal())}>
                    <div className={MyHeader.menuItemContent}>
                        <img src={documentVersionIcon} alt="Versions" className={MyHeader.menuIcon} />
                        <span className={MyHeader.menuIconLabel}>Versions</span>
                    </div>
                </Menu.Item>
            )}
            {!isReadOnly && documentInformation.createBy == userInformation.userId && !isTemplateDocument && (
                <Menu.Item key="share" onClick={() => setShareModalOpen(true)}>
                    <div className={MyHeader.menuItemContent}>
                        <img src={shareBtn} alt="Share" className={MyHeader.menuIcon} />
                        <span className={MyHeader.menuIconLabel}>Share</span>
                    </div>
                </Menu.Item>
            )}
            <Menu.Item key="mode" onClick={() => { /* keep Modes toggle simple */ }}>
                <div className={MyHeader.menuItemContent}>
                    <img src={darkIcon} alt="Mode" className={MyHeader.menuIcon} />
                    <span className={MyHeader.menuIconLabel}>Mode</span>
                </div>
            </Menu.Item>
            {isTemplateDocument && (
                <Menu.Item key="template-toggle">
                    <TemplateActiveToggle viewMode="menu" onMenuClick={() => setDropdownOpen(false)} />
                </Menu.Item>
            )}
            {isTemplateDocument && (
                <Menu.Item key="template-thumbnail">
                    <TemplateThumbnail viewMode="menu" onMenuClick={() => setDropdownOpen(false)} />
                </Menu.Item>
            )}
            {/* Profile removed from hamburger menu since the avatar is present in the header */}
        </Menu>
    );

    const titleBarRef = useRef(null);

    return (
        <>
            <div className={MyHeader.rightHeader}>
                <div className={MyHeader.titleBarButtons} ref={titleBarRef}>
                    {isTemplateDocument && (
                        <div className={`${MyHeader.iconContainer} ${MyHeader.switchContainer}`}>
                            <TemplateActiveToggle />
                        </div>
                    )}
                    {isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <TemplateThumbnail />
                        </div>
                    )}
                    {/* Member group (desktop only)*/}
                    {!isMobile && members.length > 0 && !isTemplateDocument && (
                        <div className={MyHeader.titleBarItem}>
                            <Dropdown overlay={<MembersDropdown />} trigger={['click']} visible={membersDropdownVisible} onVisibleChange={(vis) => setMembersDropdownVisible(vis)} placement="bottomRight">
                                <div
                                    className={`${MyHeader.memberGroup} ${MyHeader.memberButton}`}
                                    title="Members"
                                    role="button"
                                    tabIndex={0}
                                >
                                    <div className="member-avatar-container" style={{ width: 30 }}><MembersGroup size={24} /></div>
                                </div>
                            </Dropdown>
                        </div>
                    )}
                    {!isReadOnly && !isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <CompleteDocument />
                        </div>
                    )}
                    {!isReadOnly && !isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <VersionsModal leftRef={leftActionsRef} />
                        </div>
                    )}
                    {!isReadOnly && documentInformation.createBy == userInformation.userId && !isTemplateDocument && (
                        <div className={MyHeader.iconContainer}>
                            <ShareModal />
                        </div>
                    )}
                    <div className={MyHeader.iconContainer}>
                        <Modes isMobile={isMobile} />
                    </div>
                    <div className={`${MyHeader.iconContainer} ${MyHeader.avatarIconContainer}`}>
                        <HeaderAvatar />
                    </div>
                    <div className={`${MyHeader.iconContainer} ${MyHeader.hamburger}`}>
                        <Dropdown overlay={menu} trigger={['click']} visible={dropdownOpen} onVisibleChange={(vis) => setDropdownOpen(vis)} placement="bottomRight">
                            <MenuOutlined className={MyHeader.hamburgerIcon} />
                        </Dropdown>
                    </div>
                    {/* Mobile-only avatar placed after hamburger so profile avatar is visible on the right */}
                    <div className={`${MyHeader.iconContainer} ${MyHeader.avatarMobile}`}>
                        <HeaderAvatar />
                    </div>
                </div>
            </div>
            <Modal
                title={"Share with people and Groups"}
                visible={shareModalOpen}
                onOk={() => dispatch(closeShareModal())}
                onCancel={() => dispatch(closeShareModal())}
                footer={false}
            >
                <ShareModalContent shareUrl={null} setIsModalVisible={() => dispatch(closeShareModal())} privacy={sharePrivacy} setPrivacy={setSharePrivacy} />
            </Modal>

            <Drawer title="Version history" placement="right" onClose={() => dispatch(closeVersionModal())} visible={versionDrawerOpen}>
                <div>
                    <VersionModalContent open={versionDrawerOpen} setOpen={() => dispatch(closeVersionModal())} setShowVersionButtons={() => { }} />
                </div>
            </Drawer>

            <Drawer title="Members" placement="right" onClose={() => setMembersDrawerOpen(false)} visible={membersDrawerOpen}>
                <div>
                    <DocumentMembers />
                </div>
            </Drawer>
        </>
    );
};

export default RightHeader;